import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IMerchContractsTime } from './types';

export const useGetMerchContractFuture = (MerchId: string) => {
    const { responseHandler } = useResponseHandler();
    return useQuery<
      IMerchContractsTime,
      DefaultError
    >({
      queryKey: ['merch-contract-future', MerchId],
      async queryFn() {
        const response = await apiClient({
          method: 'GET',
          url: `Merch/Contract/Future`,
          params: { MerchId },
        });
  
        return responseHandler(response, {
          groupName: `useGetMerchContractFuture - ${MerchId}`,
        });
      },
    });
  };
  
  export const useGetMerchContractHistory = (MerchId: string) => {
    const { responseHandler } = useResponseHandler();
    return useQuery<
      IMerchContractsTime,
      DefaultError
    >({
      queryKey: ['merch-contract-history', MerchId],
      async queryFn() {
        const response = await apiClient({
          method: 'GET',
          url: `Merch/Contract/History`,
          params: { MerchId },
        });
  
        return responseHandler(response, {
          groupName: `useGetMerchContractHistory - ${MerchId}`,
        });
      },
    });
  };
  